import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
type FormErrorSummaryProps = {
  count: number;
};
export function FormErrorSummary({
  count
}: FormErrorSummaryProps) {
  if (count === 0) return null;
  return <div role="alert" className="flex gap-3 border border-danger/30 bg-danger/5 px-4 py-3.5" data-id="element-65" data-mp="1m910sgc46a08">
      <AlertCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-danger" aria-hidden="true" data-id="element-66" data-mp="1r83wha67f3vj" />
      <p className="text-sm text-ink" data-id="element-67" data-mp="2ewdc1uctqve8">
        {count === 1 ? 'One field needs your attention before this can be completed.' : `${count} fields need your attention before this can be completed.`}
      </p>
    </div>;
}